const doc = [({"da":({"js":({"admin":({"element_feedback":({"enter_a_feedback_question":"Indtast et feedback spørgsmål"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;